module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value-chain"
  }, [_c('div', {
    staticClass: "chain"
  }, [_c('div', {
    staticClass: "chain__title"
  }, [_vm._v("\n            " + _vm._s(_vm.data.first_name) + "\n            "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "display": "inline-block"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-file-alt fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.offer.count) + "\n                    ")]), _vm._v("\n                    tilbud, der afventer afgørelse\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Potentielt DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.offer.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Potentiel omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.offer.expected_revenue)) + "\n                ")]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.offer.count > 0 ? ((_vm.data.offer.has_budget / _vm.data.offer.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.offer.has_budget) + " / " + _vm._s(_vm.data.offer.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-inbox-in fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.open.count) + "\n                    ")]), _vm._v("\n                    opgaver, der ikke er påbegyndt\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.open.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.open.expected_revenue)) + "\n                ")]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.open.count > 0 ? ((_vm.data.open.has_budget / _vm.data.open.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.open.has_budget) + " / " + _vm._s(_vm.data.open.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-clock fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.ongoing.count) + "\n                    ")]), _vm._v("\n                    igangværende opgaver,\n                    "), _c('br'), _vm._v("\n                    der arbejdes på\n                ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("Værdi, salgspris")]), _vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.data.ongoing.value_with_avg_cp)) + "\n                    ")])]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.ongoing.count > 0 ? ((_vm.data.ongoing.has_budget / _vm.data.ongoing.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.ongoing.has_budget) + " / " + _vm._s(_vm.data.ongoing.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-check-circle fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.unbilled.count) + "\n                    ")]), _vm._v("\n                    afsluttede opgaver,\n                    "), _c('br'), _vm._v("\n                    der ikke er fakturerede\n                ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Værdi, salgspris")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.unbilled.value_with_avg_cp)) + "\n                ")]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.unbilled.count > 0 ? ((_vm.data.unbilled.has_budget / _vm.data.unbilled.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.unbilled.has_budget) + " / " + _vm._s(_vm.data.unbilled.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-envelope-open-dollar fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.unpaid_invoices.count) + "\n                    ")]), _vm._v("\n                    fakturaer, der endnu ikke er betalt\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.unpaid_invoices.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.unpaid_invoices.expected_revenue)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-calendar-exclamation fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.overdue_invoices.count) + "\n                    ")]), _vm._v("\n                    fakturaer med overskredet betaling\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.overdue_invoices.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.overdue_invoices.expected_revenue)) + "\n                ")])])])]), _vm._v("\n\n    Vælg en af nedenstående bokse og scroll ned på siden for at se de enkelte opgaver/fakturaer\n    "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "number-overview"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Tilbud",
      "description": "der afventer afgørelse",
      "number": _vm.data.offer.count,
      "icon": "file-alt",
      "state": "avg",
      "doEmit": true,
      "selected": _vm.selectedTable === 'offer',
      "tooltipIdentifier": "index.offerProjects"
    },
    on: {
      "clicked": function($event) {
        return _vm.showTable('offer')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Opgaver",
      "description": "der endnu ikke er påbegyndt",
      "number": _vm.data.open.count,
      "icon": "inbox-in",
      "state": "avg",
      "doEmit": true,
      "selected": _vm.selectedTable === 'open',
      "tooltipIdentifier": "index.openProjects"
    },
    on: {
      "clicked": function($event) {
        return _vm.showTable('open')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Igangværende opgaver",
      "description": "der arbejdes på lige nu",
      "number": _vm.data.ongoing.count,
      "icon": "clock",
      "state": "bad",
      "doEmit": true,
      "selected": _vm.selectedTable === 'ongoing',
      "tooltipIdentifier": "index.ongoingProjects"
    },
    on: {
      "clicked": function($event) {
        return _vm.showTable('ongoing')
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('number-card', {
    attrs: {
      "heading": "Igangværende opgaver",
      "description": 'uden registreringer i ' + _vm.$store.state.config.companyMeta.settings.snoozed_days + ' dage ',
      "number": _vm.data.snoozed.count,
      "icon": "snooze",
      "state": "bad",
      "doEmit": true,
      "selected": _vm.selectedTable === 'snoozed',
      "tooltipIdentifier": "index.snoozedProjects"
    },
    on: {
      "clicked": function($event) {
        return _vm.showTable('snoozed')
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('number-card', {
    attrs: {
      "heading": "Reklamationer",
      "description": "der ikke er afsluttet",
      "number": _vm.data.claims.count,
      "icon": "comment-exclamation",
      "state": "good",
      "doEmit": true,
      "selected": _vm.selectedTable === 'claims',
      "tooltipIdentifier": "index.openClaims"
    },
    on: {
      "clicked": function($event) {
        return _vm.showTable('claims')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Afsluttede opgaver",
      "description": "der ikke er fakturerede",
      "number": _vm.data.unbilled.count,
      "icon": "envelope-open-dollar",
      "state": "avg",
      "doEmit": true,
      "selected": _vm.selectedTable === 'noInvoice',
      "tooltipIdentifier": "index.unbilledProjects"
    },
    on: {
      "clicked": function($event) {
        return _vm.showTable('noInvoice')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Fakturaer",
      "description": "der endnu ikke er betalt",
      "number": _vm.data.unpaid_invoices.count,
      "icon": "envelope-open-dollar",
      "state": "avg",
      "doEmit": true,
      "selected": _vm.selectedTable === 'unpaid',
      "tooltipIdentifier": "index.unpaidInvoices"
    },
    on: {
      "clicked": function($event) {
        return _vm.showTable('unpaid')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Fakturaer",
      "description": 'hvor betaling er overskredet med ' + _vm.$store.state.config.companyMeta.settings.overdue_days + ' dage',
      "number": _vm.data.overdue_invoices.count,
      "icon": "calendar-exclamation",
      "state": "bad",
      "doEmit": true,
      "selected": _vm.selectedTable === 'exceededPayments',
      "tooltipIdentifier": "index.overdueInvoices"
    },
    on: {
      "clicked": function($event) {
        return _vm.showTable('exceededPayments')
      }
    }
  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tables"
    }
  }, [(_vm.selectedTable === 'offer') ? _c('table-offer', {
    attrs: {
      "employeeId": _vm.data.relation_id,
      "employeeName": _vm.data.first_name
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.scrollNow()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTable === 'open') ? _c('table-open', {
    attrs: {
      "employeeId": _vm.data.relation_id,
      "employeeName": _vm.data.first_name
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.scrollNow()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTable === 'ongoing') ? _c('table-ongoing', {
    attrs: {
      "employeeId": _vm.data.relation_id,
      "employeeName": _vm.data.first_name
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.scrollNow()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTable === 'snoozed') ? _c('table-snoozed', {
    attrs: {
      "employeeId": _vm.data.relation_id,
      "employeeName": _vm.data.first_name
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.scrollNow()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTable === 'claims') ? _c('table-claims', {
    attrs: {
      "employeeId": _vm.data.relation_id,
      "employeeName": _vm.data.first_name
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.scrollNow()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTable === 'noInvoice') ? _c('table-noinvoice', {
    attrs: {
      "employeeId": _vm.data.relation_id,
      "employeeName": _vm.data.first_name
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.scrollNow()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTable === 'unpaid') ? _c('table-unpaid', {
    attrs: {
      "employeeId": _vm.data.relation_id,
      "employeeName": _vm.data.first_name
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.scrollNow()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTable === 'exceededPayments') ? _c('table-overdue', {
    attrs: {
      "employeeId": _vm.data.relation_id,
      "employeeName": _vm.data.first_name
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.scrollNow()
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "revenue",
    staticStyle: {
      "opacity": "0"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Placeholder")]), _vm._v("\n                    Placeholder\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "revenue",
    staticStyle: {
      "opacity": "0"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Placeholder")]), _vm._v("\n                    Placeholder\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f49ff36e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsibles/learning/components/responsibleValuechainSingle.vue
// module id = 946
// module chunks = 0